module.exports = __webpack_public_path__ + "static/img/Bottas.c69bfc4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Bottas.jpg
// module id = DRQi
// module chunks = 1